<template>
  <div class="top-navbar gap-3">
    <button
      v-tooltip.bottom="mainMenuToggleLabel"
      type="button"
      class="main-menu-toggle d-none d-md-flex"
      data-dd-action-name="topbar:menu-toggle"
      :aria-label="mainMenuToggleLabel"
      :aria-expanded="String(!isMainMenuCollapsed)"
      @click="toggleMainMenuCollapsed"
    >
      <i class="fa-solid fa-bars"></i>
    </button>
    <div class="topbar-logo d-md-none">
      <img
        :src="`${baseUrl}/img/flexigo-logo.png`"
        :srcset="`${baseUrl}/img/flexigo-logo.png, ${baseUrl}/img/flexigo-logo@2x.png, ${baseUrl}/img/flexigo-logo@3x.png`"
        alt="Flexigo"
      />
    </div>
    <div class="hstack gap-3">
      <notificationModal v-if="isRider" />
      <button-dropdown
        v-if="showSwitcher"
        class="environment-switcher"
        data-dd-action-name="topbar:environment-switcher"
        :items="environments"
        :initial-value="currentEnvironment"
        label-field="name"
        :empty-label="$t('flexigo.common.environment')"
        @select="onSelectEnvironment"
      />
      <div class="topbar-user">
        <div class="initials-circle d-md-flex d-none">
          <div class="initials">{{ initials }}</div>
        </div>
        <div class="user-details">
          <div class="username" data-bs-toggle="dropdown">
            <a href="#" data-dd-action-name="topbar:user-menu" @click.prevent
              >{{ fullName }}
              <svg width="8" height="5" viewBox="0 0 8 5" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M.538 0h6.924c.479 0 .718.637.38 1.011L4.38 4.827a.505.505 0 0 1-.762 0L.16 1.01C-.181.637.059 0 .539 0z"
                  fill="#363647"
                  fill-rule="nonzero"
                />
              </svg>
            </a>
          </div>
          <ul class="dropdown-menu">
            <!-- <li><a class="dropdown-item" href="#">Action</a></li> -->
            <!-- <li><a class="dropdown-item" href="#">Change Password</a></li> -->
            <li>
              <router-link
                :to="{ name: 'ChangePassword' }"
                class="dropdown-item"
                data-dd-action-name="topbar:change-password"
                >{{ $t('flexigo.common.changePassword') }}</router-link
              >
            </li>
            <li>
              <a class="dropdown-item" href="#" data-dd-action-name="topbar:logout" @click.prevent="logout">{{
                $t('flexigo.employee.dashboard.signOut')
              }}</a>
            </li>
            <!-- <li><hr class="dropdown-divider"></li> -->
            <!-- <li><a class="dropdown-item" href="#">Separated link</a></li> -->
          </ul>
          <div class="email text-secondary">{{ email }}</div>
        </div>
        <div class="hamburger-menu d-md-none" data-dd-action-name="topbar:mobile-menu" @click="toggleSideMenu">
          <svg width="35" height="35" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <rect x="15" y="25" width="70" height="5" fill="#0B0B17"></rect>
            <rect x="15" y="45" width="70" height="5" fill="#0B0B17"></rect>
            <rect x="15" y="65" width="70" height="5" fill="#0B0B17"></rect>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/modules/Flexigo/services/auth';
import toaster from '@/modules/Flexigo/mixins/toaster';
import { endRumSession } from '@/modules/Flexigo/helpers/rum';
import useEnvironmentSwitcher from '../../composables/useEnvironmentSwitcher';
import ButtonDropdown from '../dropdown/button-dropdown.vue';
import notificationModal from './notificationModal.vue';

export default {
  name: 'Topbar',
  components: { notificationModal, ButtonDropdown },
  mixins: [toaster],
  setup() {
    const { environments, currentEnvironment, showSwitcher, isSwitching, error, switchEnvironment } =
      useEnvironmentSwitcher();
    const onSelectEnvironment = (env) => {
      if (env?.value) switchEnvironment(env.value);
    };
    return { environments, currentEnvironment, showSwitcher, isSwitching, error, onSelectEnvironment };
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
  computed: {
    fullName() {
      return this.$store.getters.userDetails.fullName;
    },
    email() {
      return this.$store.getters.userDetails.email;
    },
    initials() {
      if (!this.fullName) return '';
      const name = this.fullName;
      const words = name.trim().split(/\s+/);

      const firstInitial = words.length > 0 ? words[0][0] : ' ';
      const lastInitial = words.length > 1 ? words[words.length - 1][0] : ' ';

      return (firstInitial + lastInitial).toUpperCase();
    },
    isAdmin() {
      return this.$store.state.userDetails?.accountType;
    },
    isRider() {
      return this.$store.state.userDetails?.personnel?.isActive && !this.$store.state.userDetails?.accountType;
    },
    isMainMenuCollapsed() {
      return this.$store.state.isMainMenuCollapsed;
    },
    mainMenuToggleLabel() {
      return this.isMainMenuCollapsed
        ? this.$t('flexigo.common.expandMainMenu')
        : this.$t('flexigo.common.collapseMainMenu');
    },
  },
  watch: {
    error(err) {
      if (err) this.getToaster('error', this.$t('flexigo.common.environmentSwitchFailed'));
    },
  },
  methods: {
    async logout() {
      try {
        const [base] = window.location.hostname.split('.');
        const urls = {
          localhost: 'http://localhost:5431',
          secure: 'https://secure.flexigo.com?lang=tr',
          portal: 'https://portal.flexigo.com?lang=en',
          secure3: 'https://secure3.vektorteknoloji.com/flexigo/',
          timezone: 'https://timezone.flexigo.com',
        };
        await auth.logout();
        endRumSession();
        sessionStorage.clear();
        localStorage.removeItem('flexigoAutoLoginContext');
        window.location.href = urls[base];
      } catch (error) {
        console.error(error);
      }
    },
    toggleSideMenu() {
      this.$store.dispatch('toggleSideMenu');
    },
    toggleMainMenuCollapsed() {
      this.$store.dispatch('toggleMainMenuCollapsed');
    },
  },
};
</script>

<style lang="scss" scoped></style>
